(function () {
  var suppressDrawerUntil = 0;
  var drawerPatched = false;
  var drawerRefreshing = false;

  function patchCartDrawer() {
    if (drawerPatched) return;

    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') return;

    var originalOpen = drawer.open.bind(drawer);
    drawer.open = function (opener) {
      if (Date.now() < suppressDrawerUntil) return;
      originalOpen(opener);
    };
    drawerPatched = true;
  }

  function findProductImage(productForm) {
    var scope = productForm.closest('.shopify-section') || document;
    return scope.querySelector(
      '.ocean-main-image, .product__media-item.is-active img, .product__media img, .card__media img, .media img'
    );
  }

  function animateImageToCart(productForm) {
    var image = findProductImage(productForm);
    var cartIcon = document.querySelector('#cart-icon-bubble');
    var submitButton = productForm.querySelector('[type="submit"][name="add"], .ocean-add-btn');
    if (!image || !cartIcon || !image.getBoundingClientRect) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var imageRect = image.getBoundingClientRect();
    var cartRect = cartIcon.getBoundingClientRect();
    var imageIsVisible = imageRect.bottom > 0 && imageRect.top < window.innerHeight;
    var cartIsVisible = cartRect.bottom > 0 && cartRect.top < window.innerHeight;
    var sourceRect = imageIsVisible || !submitButton ? imageRect : submitButton.getBoundingClientRect();
    var targetCenterX = cartIsVisible ? cartRect.left + cartRect.width / 2 : window.innerWidth - 28;
    var targetCenterY = cartIsVisible ? cartRect.top + cartRect.height / 2 : 28;
    if (!sourceRect.width) return;

    var size = Math.min(92, Math.max(56, sourceRect.width * 0.22));
    var sourceCenterX = sourceRect.left + sourceRect.width / 2;
    var sourceCenterY = sourceRect.top + sourceRect.height / 2;
    var flyer = document.createElement('div');
    flyer.className = 'cart-add-flyer';
    var flyerImage = image.cloneNode(true);
    flyerImage.removeAttribute('id');
    flyer.appendChild(flyerImage);
    flyer.style.width = size + 'px';
    flyer.style.height = size + 'px';
    flyer.style.left = sourceCenterX - size / 2 + 'px';
    flyer.style.top = sourceCenterY - size / 2 + 'px';
    document.body.appendChild(flyer);

    var endX = targetCenterX - sourceCenterX;
    var endY = targetCenterY - sourceCenterY;
    var animation = flyer.animate(
      [
        { transform: 'translate(0, 0) scale(0.65)', opacity: 0 },
        { transform: 'translate(0, -16px) scale(1.08)', opacity: 1, offset: 0.18 },
        { transform: 'translate(' + endX * 0.45 + 'px, ' + (endY * 0.35 - 60) + 'px) scale(0.82)', opacity: 0.96, offset: 0.65 },
        { transform: 'translate(' + endX + 'px, ' + endY + 'px) scale(0.18)', opacity: 0.2 }
      ],
      { duration: 1000, easing: 'cubic-bezier(.22,.75,.28,1)' }
    );

    animation.onfinish = function () {
      flyer.remove();
      cartIcon.classList.remove('cart-add-icon-success');
      void cartIcon.offsetWidth;
      cartIcon.classList.add('cart-add-icon-success');
      window.setTimeout(function () {
        cartIcon.classList.remove('cart-add-icon-success');
      }, 700);
    };
  }

  function showAddedConfirmation(text, isError) {
    var existing = document.querySelector('.cart-add-confirmation');
    if (existing) existing.remove();

    var message = document.createElement('div');
    message.className = 'cart-add-confirmation' + (isError ? ' cart-add-confirmation--error' : '');
    message.setAttribute('role', 'status');
    message.textContent = text || '✓ Added to cart';
    document.body.appendChild(message);
    window.setTimeout(function () {
      message.remove();
    }, 1900);
  }

  // Swap the freshly rendered drawer markup in ourselves. The theme's own
  // renderContents() looks up an element with id "cart-drawer" (which this
  // build does not render) and can fail silently, leaving the drawer blank.
  function applyDrawerMarkup(drawer, sections, open) {
    var html = sections && sections['cart-drawer'];
    if (!drawer || !html) return false;

    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var newInner = parsed.querySelector('.drawer__inner');
    var currentInner = drawer.querySelector('.drawer__inner');
    if (!newInner || !currentInner) return false;

    currentInner.innerHTML = newInner.innerHTML;
    if (newInner.getAttribute('class')) currentInner.className = newInner.getAttribute('class');

    var newDrawer = parsed.querySelector('cart-drawer');
    var hasItems = !!currentInner.querySelector('.cart-drawer-item');
    var isEmpty = !!(newDrawer && newDrawer.classList.contains('is-empty')) && !hasItems;
    drawer.classList.toggle('is-empty', isEmpty);

    if (sections['cart-icon-bubble']) {
      var parsedBubble = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      var newBubble = parsedBubble.querySelector('#cart-icon-bubble');
      var currentBubble = document.querySelector('#cart-icon-bubble');
      if (newBubble && currentBubble) currentBubble.innerHTML = newBubble.innerHTML;
    }

    if (open) {
      if (typeof drawer.open === 'function') drawer.open();
      drawer.classList.add('active');
    }

    return true;
  }

  // Render the freshly fetched drawer sections, then verify they really
  // landed. The theme's own renderer is unreliable in this build, so the
  // verification step injects the markup ourselves when needed.
  function renderDrawerFromSections(drawer, sections, open) {
    var html = sections && sections['cart-drawer'];
    if (!drawer || !html) return false;

    var expectsItems = html.indexOf('cart-drawer-item') !== -1;
    suppressDrawerUntil = 0;

    try {
      var result = drawer.renderContents(
        { sections: sections, item_count: expectsItems ? 1 : 0 },
        !!open
      );
      if (result && typeof result.then === 'function') {
        result.catch(function () {
          applyDrawerMarkup(drawer, sections, !!open);
        });
      }
    } catch (error) {
      applyDrawerMarkup(drawer, sections, !!open);
    }

    function verify() {
      var hasItems = !!drawer.querySelector('.cart-drawer-item');
      if (expectsItems !== hasItems) {
        applyDrawerMarkup(drawer, sections, !!open);
        return;
      }
      if (hasItems && drawer.classList.contains('is-empty')) {
        drawer.classList.remove('is-empty');
      }
    }

    window.setTimeout(verify, 250);
    window.setTimeout(verify, 900);

    return true;
  }

  // Refresh the cart drawer through the Section Rendering API (the same path
  // the cart icon uses) so the drawer is fully populated right after adding an
  // item. Note: POSTing to cart/update.js with empty "updates" returns
  // "sections": null, which left the drawer blank until a page reload.
  function refreshCartDrawer(drawer, open) {
    var rootUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    var separator = rootUrl.indexOf('?') === -1 ? '?' : '&';

    return fetch(rootUrl + separator + 'sections=cart-drawer,cart-icon-bubble', {
      // Accept: application/json is required on *.myshopify.com, otherwise
      // Shopify 301-redirects to the primary domain and the fetch fails.
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart refresh failed.');
        return response.json();
      })
      .then(function (sections) {
        var html = sections && sections['cart-drawer'];
        if (!html) throw new Error('Cart drawer section is unavailable.');
        if (!drawer) return sections;
        renderDrawerFromSections(drawer, sections, !!open);
        return sections;
      });
  }

  // Safety net: whichever code path opens the drawer, if it opens without any
  // items while the cart really has items, render the drawer ourselves.
  var lastEnsureAt = 0;

  function ensureDrawerContent() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    if (!drawer.classList.contains('active')) return;

    var hasItems = !!drawer.querySelector('.cart-drawer-item');
    if (hasItems) {
      if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
      return;
    }
    if (Date.now() - lastEnsureAt < 1500) return;
    lastEnsureAt = Date.now();

    var rootUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

    fetch(rootUrl + 'cart.js', {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      }
    })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        if (cart && cart.item_count > 0) {
          drawer.classList.remove('is-empty');
          if (!drawer.querySelector('.cart-drawer-item')) {
            refreshCartDrawer(drawer, false);
          }
        }
      })
      .catch(function () {
        /* nothing else to do here */
      });
  }

  function observeDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.dataset.cartDrawerObserved === 'true') return;
    drawer.dataset.cartDrawerObserved = 'true';

    new MutationObserver(function (mutations) {
      var opened = mutations.some(function (mutation) {
        return mutation.attributeName === 'class';
      });
      if (opened) window.setTimeout(ensureDrawerContent, 150);
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  function addOceanProductWithoutRedirect(form, submitButton) {
    if (submitButton.disabled) return;

    submitButton.disabled = true;
    submitButton.setAttribute('aria-busy', 'true');
    animateImageToCart(form);
    submitButton.classList.remove('cart-add-success');
    void submitButton.offsetWidth;
    submitButton.classList.add('cart-add-success');

    var formData = new FormData(form);
    var drawer = document.querySelector('cart-drawer');
    var sections = drawer && typeof drawer.getSectionsToRender === 'function'
      ? drawer.getSectionsToRender().map(function (section) { return section.id; })
      : ['cart-icon-bubble'];

    formData.append('sections', sections.join(','));
    formData.append('sections_url', window.location.pathname);

    fetch(window.routes ? window.routes.cart_add_url : '/cart/add.js', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || data.status) throw new Error(data.description || 'Unable to add this item.');
          return data;
        });
      })
      .then(function (data) {
        showAddedConfirmation('✓ Added to cart');
        if (drawer && typeof drawer.renderContents === 'function') {
          return refreshCartDrawer(drawer, true).catch(function () {
            try {
              suppressDrawerUntil = 0;
              drawer.renderContents(data, true);
            } catch (error) {
              /* ignore: the toast already confirmed the add */
            }
          });
        } else if (data.sections && data.sections['cart-icon-bubble']) {
          var parser = new DOMParser();
          var parsed = parser.parseFromString(data.sections['cart-icon-bubble'], 'text/html');
          var currentBubble = document.querySelector('#cart-icon-bubble');
          var nextBubble = parsed.querySelector('#cart-icon-bubble');
          if (currentBubble && nextBubble) currentBubble.innerHTML = nextBubble.innerHTML;
        }
      })
      .catch(function (error) {
        showAddedConfirmation(error.message || 'Unable to add this item.', true);
      })
      .finally(function () {
        submitButton.disabled = false;
        submitButton.removeAttribute('aria-busy');
        window.setTimeout(function () {
          submitButton.classList.remove('cart-add-success');
        }, 500);
      });
  }

  function refreshAndOpenCartDrawer(trigger) {
    if (drawerRefreshing) return;

    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function' || typeof drawer.open !== 'function') {
      window.location.href = window.routes ? window.routes.cart_url : '/cart';
      return;
    }

    drawerRefreshing = true;
    trigger.setAttribute('aria-busy', 'true');
    var rootUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    var separator = rootUrl.indexOf('?') === -1 ? '?' : '&';

    fetch(rootUrl + separator + 'sections=cart-drawer,cart-icon-bubble', {
      // Accept: application/json is required on *.myshopify.com, otherwise
      // Shopify 301-redirects to the primary domain and the fetch fails.
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to refresh cart.');
        return response.json();
      })
      .then(function (sections) {
        if (!sections['cart-drawer']) throw new Error('Cart drawer section is unavailable.');
        renderDrawerFromSections(drawer, sections, true);
        drawer.open(trigger);
      })
      .catch(function () {
        window.location.href = window.routes ? window.routes.cart_url : '/cart';
      })
      .finally(function () {
        drawerRefreshing = false;
        trigger.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('#cart-icon-bubble');
    if (!trigger || !document.querySelector('cart-drawer')) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    refreshAndOpenCartDrawer(trigger);
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    var submitButton = event.submitter || form.querySelector('[type="submit"][name="add"]');
    if (form.matches('.ocean-product-form') && submitButton) {
      event.preventDefault();
      event.stopImmediatePropagation();
      addOceanProductWithoutRedirect(form, submitButton);
      return;
    }

    var productForm = form.closest('product-form');
    if (!productForm || !submitButton || submitButton.dataset.skipCartButton === 'true') return;
    if (form.querySelector('[name="id"][data-skip-cart="true"]')) return;

    suppressDrawerUntil = Date.now() + 4000;
    patchCartDrawer();
    animateImageToCart(productForm);
    submitButton.classList.remove('cart-add-success');
    void submitButton.offsetWidth;
    submitButton.classList.add('cart-add-success');
    window.setTimeout(function () {
      submitButton.classList.remove('cart-add-success');
      var errorMessage = productForm.querySelector('.product-form__error-message-wrapper:not([hidden])');
      if (!errorMessage) showAddedConfirmation('✓ Added to cart');
    }, 800);
  }, true);

  function initCartDrawerHelpers() {
    patchCartDrawer();
    observeDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartDrawerHelpers);
  } else {
    initCartDrawerHelpers();
  }
})();
